import React from 'react';
import styled from 'styled-components';
import TitledCell from '../UI/TitledCell/TitledCell';

const LeftAlignedOrderedList = styled.ol`
    text-align: left;
`;

const LeftAlignedUnorderedList = styled.ul`
    text-align: left;
    list-style-type: square;
`;

const TitledList = (props) => {
    const items = props.list.map((item, index) => <li key={index}>{item}</li>);
    const list = props.ordered ? 
        <LeftAlignedOrderedList>{items}</LeftAlignedOrderedList> :
        <LeftAlignedUnorderedList>{items}</LeftAlignedUnorderedList>;

    return (<TitledCell title={props.title}>
        {list}
    </TitledCell>);
};

export default TitledList;


// WEBPACK FOOTER //
// ./src/components/GameInfo/TitledList.js